import React from 'react';
import { observer } from 'mobx-react';

import PanelInfo from "../../widgets/PanelInfo";

let AccountBalancePanel = ({ ...props }) => {

    let studentId = props.studentId || props.store.user.studentId;

    let student = props.store.students.getById(studentId)

    return (
        <PanelInfo flexDirection="column">
            <div className="top">
                <span>Remaining Work Study Balance</span>
            </div>
            <div label="Remaining work study balance" className="bottom">
                <span className="panelInfoLarge">${student.balance.toFixed(2)}</span>
                <span>/${student.awardAmount.toFixed(2)}</span>
            </div>
        </PanelInfo>
    )
}


export default observer(AccountBalancePanel);